import React from 'react'

function Footer() {
    return (
        <div className='flex flex-col lg:flex-row items-center text-white lg:justify-between w-full  font-light lg:px-32  '>


            <p className='pb-10'>Copyright © 2024 Web3Forge Studio</p>



            <p className='pb-10'>Powered by Web3Forge Studio</p>

        </div>
    )
}

export default Footer